import GameObject from '../../../../GameObject/GameObject';
import IWorldComponent, {
    WorldComponentType,
} from '../../Data/Components/IWorldComponent';
import Suitcase from '../../../../Prototype/World/Suitcase';
import Scene from '../../../../Scene/Scene';

const MAP_COMPONENTS: Map<
    WorldComponentType,
    { new (id?: string): any }
> = new Map<WorldComponentType, { new (id?: string): any }>([
    [WorldComponentType.SUITCASE, Suitcase],
]);

export default class MapComponentHandler {
    public static addMapComponents(
        components: IWorldComponent[],
        levelNumber: number,
        scene: Scene
    ): GameObject[] {
        const mapComponents: GameObject[] = [];
        components.forEach((component: IWorldComponent) => {
            if (MAP_COMPONENTS.has(component.type)) {
                mapComponents.push(
                    GameObject.Instantiate(MAP_COMPONENTS.get(component.type), {
                        scene,
                        ...component,
                    })
                );
            } else {
                console.warn(
                    `Map component type '${component.type}' not found`
                );
            }
        });
        return mapComponents;
    }
}
